// GENERATED by scripts/build-icons.mjs from icons/panel-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const PanelLeft = createIcon('panel-left', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ['path', { d: "M9 3v18" }],
])
